import { useMutation } from '@tanstack/react-query'

import { useStandardService } from '../../../hooks/useStandardService'
import { useNavigationParams } from '../../../system/useNavigationParams'
import { fetchFromService } from '../fetchFromService'

type TriggerProps = {
  mappingId: string
  /** Date the mapping to export has to be active on, its from date included. */
  at: string
}

/**
 * Fetches the Excel document of a GL mapping straight from the connected component,
 * which owns the configuration on the standard branch. The configuration component,
 * and therefore its conversion service, is not available there.
 */
export const useMutateFetchStandardGlMapExcel = () => {
  const service = useStandardService()
  const { layer } = useNavigationParams()

  return useMutation({
    mutationFn: async ({ mappingId, at }: TriggerProps) => {
      const response = await fetchFromService({
        serviceConfig: service.api.OpenAPI,
        serviceName: 'standard',
        path: `/configuration/glmappings/excel/${encodeURIComponent(mappingId)}/${encodeURIComponent(at)}/latest`,
        method: 'GET',
        // TODO: Add proper layering support once the standard service supports it
        headers: layer.tenantId ? { 'x-tenant-id': layer.tenantId } : undefined,
        errorMessage: 'Failed to fetch the GL-map Excel document',
      })

      return await response.blob()
    },
  })
}
